export const APP_VERSION = process.env.REACT_APP_VERSION;
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const API_NEXT_BASE_URL = process.env.REACT_APP_API_NEXT_BASE_URL;
export const ENABLE_REDUX_LOGGER = false;
